import underscored from 'underscore.string/underscored';

angular.module('gym.waivers').controller('MergeWaiverCtrl', ["$scope", "$state", "flash", "EmploymentService", "Contacts", "ContactBadgeService", "WaiverMerges", "waiver", "waiverMerge", function($scope, $state, flash, EmploymentService, Contacts, ContactBadgeService, WaiverMerges, waiver, waiverMerge) {
  var addPrimaryContact, createMergedContacts, hasExistingContact, isContactsInvalid, signedWaiverContacts, updatePrimaryContact;
  $scope.permissions = EmploymentService.get().permissions;
  if (!$scope.permissions.merge_signed_waivers) {
    $state.go('gym.dashboard');
  }
  $scope.waiver = waiver;
  $scope.waiverMerge = waiverMerge;
  signedWaiverContacts = waiver.signed_waiver_attributes.signed_waiver_contacts_attributes;
  $scope.waiverContact = signedWaiverContacts[0];
  $scope.waiverDependants = signedWaiverContacts.slice(1);
  $scope.pageParams = {
    dependantContacts: {}
  };
  $scope.getRelationships = function(id) {
    return Contacts.one(id.toString()).all('contact_relationships').getList({
      children_only: 1
    }).then(function(contacts) {
      $scope.contactRelationships = contacts.plain();
      if (!$scope.contactRelationships.length) {
        return _.each($scope.pageParams.dependantContacts, function(item, index) {
          return $scope.pageParams.dependantContacts[index].mergeType = 'link_to_unrelated';
        });
      }
    });
  };
  createMergedContacts = function() {
    return signedWaiverContacts.map(function(item) {
      var merged;
      merged = {
        id: item.id,
        contact_id_was: item.contact_id,
        position: item.position,
        new_contact: false
      };
      if (!item.contact_archived) {
        merged.contact_id_is = item.contact_id;
        merged.name = `${item.first_name} ${item.last_name}`;
        if (item.position === 1) {
          $scope.getRelationships(item.contact_id);
        }
      }
      return merged;
    });
  };
  $scope.isSignedAsAdult = function() {
    return waiver.signed_waiver_attributes.signed_as === 'signed_as_adult';
  };
  $scope.mergedContacts = createMergedContacts();
  $scope.addPrimaryContact = addPrimaryContact = function(id) {
    return Contacts.get(id).then(function(contact) {
      updatePrimaryContact(contact);
      $scope.pageParams.selectedContact = [contact];
      return $scope.getRelationships(contact.id);
    });
  };
  $scope.dropdownPlaceholder = function() {
    var ref;
    if ((ref = $scope.contactRelationships) != null ? ref.length : void 0) {
      return 'Choose Dependant';
    } else {
      return 'No children found';
    }
  };
  $scope.onContactAdded = function(contact) {
    $scope.getRelationships(contact.id);
    $scope.pageParams.selectedContact = [contact];
    return updatePrimaryContact(contact);
  };
  $scope.onContactRemoved = function() {
    $scope.mergedContacts = createMergedContacts();
    return $scope.contactRelationships = [];
  };
  $scope.onDependantContactAdded = function(c, index) {
    $scope.pageParams.dependantContacts[index].selected = [c];
    return Contacts.get(c.id).then(function(contact) {
      var item;
      item = {
        related_contact_id: contact.id,
        related_contact_name: contact.name,
        related_contact_dob: contact.contact_information.dob,
        related_contact_email: contact.contact_information.email,
        related_contact_type: contact.type,
        related_contact_status: contact.status,
        related_contact_phone_number: contact.contact_information.phone_number
      };
      return $scope.onDependantSelect(item, index);
    });
  };
  $scope.onDependantContactRemoved = function(index) {
    return $scope.clearMergedContact(index);
  };
  $scope.onDependantContactMergeTypeChange = function(index) {
    switch ($scope.pageParams.dependantContacts[index].mergeType) {
      case 'add_new_contact':
        $scope.mergedContacts[index].new_contact = true;
        break;
      default:
        $scope.mergedContacts[index].new_contact = false;
    }
    $scope.clearMergedContact(index);
    $scope.pageParams.dependantContacts[index].selected = [];
    return $scope.pageParams.dependantContacts[index].selectedFromList = void 0;
  };
  $scope.getContacts = function(text) {
    return Contacts.getList({
      all_contacts_search: text
    });
  };
  $scope.underscored = function(str) {
    return underscored(str.toLowerCase());
  };
  $scope.getContactType = function(contact) {
    return underscored(contact.contact_type);
  };
  $scope.onDependantSelectFromExistingList = function(contact, index) {
    $scope.pageParams.dependantContacts[index].selectedFromList = contact;
    return $scope.onDependantSelect(contact, index);
  };
  $scope.onDependantSelect = function(contact, index) {
    $scope.mergedContacts[index].contact_id_is = contact.related_contact_id;
    $scope.mergedContacts[index].name = contact.related_contact_name;
    $scope.mergedContacts[index].dob = contact.related_contact_dob;
    $scope.mergedContacts[index].email = contact.related_contact_email;
    $scope.mergedContacts[index].type = contact.related_contact_type;
    $scope.mergedContacts[index].status = contact.related_contact_status;
    return $scope.mergedContacts[index].phone_number = contact.related_contact_phone_number;
  };
  $scope.clearMergedContact = function(index) {
    $scope.mergedContacts[index].contact_id_is = void 0;
    $scope.mergedContacts[index].name = void 0;
    $scope.mergedContacts[index].dob = void 0;
    $scope.mergedContacts[index].email = void 0;
    $scope.mergedContacts[index].phone_number = void 0;
    $scope.mergedContacts[index].type = void 0;
    if (index === 0) {
      return $scope.pageParams.selectedContact = [];
    }
  };
  updatePrimaryContact = function(contact) {
    var contactDetails;
    contactDetails = contact.contact_information ? contact.contact_information : contact;
    $scope.mergedContacts[0].contact_id_is = contactDetails.id;
    $scope.mergedContacts[0].name = contactDetails.first_name ? `${contactDetails.first_name} ${contactDetails.last_name}` : contactDetails.name;
    $scope.mergedContacts[0].email = contactDetails.email;
    $scope.mergedContacts[0].contact_status = contactDetails.status;
    $scope.mergedContacts[0].phone_number = contactDetails.phone_number;
    $scope.mergedContacts[0].dob = contactDetails.dob;
    return $scope.mergedContacts[0].new_contact = false;
  };
  isContactsInvalid = function() {
    return _.find($scope.mergedContacts, function(contact) {
      return !contact.contact_id_is && !contact.new_contact;
    });
  };
  $scope.onPrimaryAsNewContactToggle = function() {
    if ($scope.mergedContacts[0].new_contact) {
      $scope.clearMergedContact(0);
      return $scope.mergedContacts.forEach(function(contact, index) {
        if (index > 0 && $scope.pageParams.dependantContacts[index].mergeType === 'link_to_existing') {
          $scope.pageParams.dependantContacts[index].mergeType = 'link_to_unrelated';
          return $scope.clearMergedContact(index);
        }
      });
    }
  };
  $scope.primaryContactName = function() {
    return $scope.mergedContacts[0].name || 'parent';
  };
  $scope.getContactBadge = function(type, status) {
    return ContactBadgeService.get(type, status);
  };
  $scope.getContactStatus = function(contact) {
    return contact.status || contact.contact_status;
  };
  $scope.hasDuplicates = function(contact) {
    var matches;
    matches = $scope.mergedContacts.filter(function(item) {
      return contact.contact_id_is && item.contact_id_is === contact.contact_id_is;
    });
    return matches.length > 1;
  };
  hasExistingContact = function() {
    return $scope.mergedContacts.find(function(contact) {
      return !contact.new_contact;
    });
  };
  $scope.parentSelected = function() {
    return $scope.mergedContacts[0].contact_id_is || $scope.mergedContacts[0].new_contact;
  };
  $scope.isValid = function() {
    var hasDuplicates;
    hasDuplicates = $scope.mergedContacts.find($scope.hasDuplicates);
    return $scope.parentSelected() && !hasDuplicates;
  };
  $scope.mergeWaiver = function() {
    var cleanMergedContacts, data, params;
    if (!hasExistingContact()) {
      flash.error = "At least one signee must be linked to an existing contact";
      return;
    }
    if (isContactsInvalid()) {
      return flash.error = "Please choose a substitute for all dependants before merging.";
    } else {
      cleanMergedContacts = $scope.mergedContacts.map(function(item) {
        return _.pick(item, 'contact_id_is', 'contact_id_was', 'id', 'new_contact', 'position');
      });
      data = {
        rootObjectName: 'signed_waiver_merge',
        signed_waiver_contacts_attributes: cleanMergedContacts
      };
      params = {
        signed_waiver_id: waiverMerge.signed_waiver_id
      };
      $scope.isLoading = true;
      return WaiverMerges.post(data, params).then(function(response) {
        flash.success = "Waiver merged successfully";
        return $state.go('gym.waivers.review', {
          signed_waiver_id: waiverMerge.signed_waiver_id
        });
      }, function(response) {
        flash.error = response.data.error;
        return $scope.isLoading = false;
      });
    }
  };
  if (waiverMerge.best_guess_for_primary_contact.contact_id) {
    return addPrimaryContact(waiverMerge.best_guess_for_primary_contact.contact_id);
  }
}]);
